var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tradingview_e8053"}},[_c('VueTradingView',{attrs:{"options":{
      width: '100%',
      height: 460,
      symbol: 'BITSTAMP:BTCUSD',
      interval: 'D',
      timezone: 'Etc/UTC',
      theme: _vm.dark ? 'dark' : 'Light',
      style: '1',
      locale: 'en',
      toolbar_bg: '#f1f3f6',
      enable_publishing: false,
      withdateranges: true,
      hide_side_toolbar: false,
      allow_symbol_change: true,
      show_popup_button: true,
      popup_width: '1000',
      popup_height: '650',
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }